module.exports = __webpack_public_path__ + "img/Unidad11-3.6cd93c45.png";